<template>
	<div class="dependency-manager">
		<div class="manager-header">
			<h3>Dependencies</h3>
			<button @click="showAddDialog = true">Add Dependency</button>
		</div>

		<div class="dependency-list">
			<div v-for="dep in dependencies" :key="dep.name" class="dependency-item">
				<div class="dep-info">
					<h4>{{ dep.name }}</h4>
					<span>{{ dep.version }}</span>
				</div>
				<button @click="removeDependency(dep.name)">Remove</button>
			</div>
		</div>

		<Dialog v-model="showAddDialog">
			<DependencySearch @add="addDependency" />
		</Dialog>
	</div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import {
	  Dialog,
	  DialogContent,
	  DialogDescription,
	  DialogFooter,
	  DialogHeader,
	  DialogTitle,
	  DialogTrigger,
} from '@/components/ui/dialog'
import DependencySearch from '@/components/builder/DependencySearch.vue'

interface Dependency {
	name: string
	version: string
}

const props = defineProps({
	modelValue: {
		type: Array as () => Dependency[],
		default: () => []
	}
})

const emit = defineEmits(['update:modelValue'])

const dependencies = ref<Dependency[]>(props.modelValue)
const showAddDialog = ref(false)

const addDependency = (dep: Dependency) => {
	dependencies.value = [...dependencies.value, dep]
	emit('update:modelValue', dependencies.value)
	showAddDialog.value = false
}

const removeDependency = (name: string) => {
	dependencies.value = dependencies.value.filter(d => d.name !== name)
	emit('update:modelValue', dependencies.value)
}
</script>
